import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NgxPermissionsModule } from "ngx-permissions";
import { TareaModule } from "../../../forms/tareas/tarea.module";
import {
    ReactiveFormsModule,
    FormsModule
} from "@angular/forms";
import { PipesModule } from "../../../pipes/pipes.module";
import { TareasRoutingModule } from "./tareas-routing.module";
import { BotonToggleModule } from "../../../components/boton/boton-toggle.module";
import { TareasComponent } from "./tareas.component";
import { MaterialModule } from "../../../components/material/material.module";

@NgModule({
    imports: [
        CommonModule,
        NgxPermissionsModule.forChild(),
        TareaModule,
        ReactiveFormsModule,
        FormsModule,
        PipesModule,
        TareasRoutingModule,
        BotonToggleModule,
        MaterialModule,
    ],
    declarations: [
        TareasComponent
    ],
    providers: [
    ],
    entryComponents: [
    ]
})
export class TareasModule { }